export const formatDashboardNumber = (value: number) => {
  return value.toLocaleString("en-US");
};

export const dashboardTooltipStyle = {
  borderRadius: "10px",
  borderColor: "rgb(100 116 139 / 0.45)",
  backgroundColor: "var(--color-bg-card, var(--background))",
  color: "var(--foreground)",
};
